<template>
  <div class="scrolling-links">
    <figure class="item-wrapper" v-if="features.flyTalks">
      <img
        class="item-image"
        draggable="false"
        src="@/assets/app-icons/home/fly-talks.png"
        alt="Fly talks"
        onmousedown="return false"
        width="240"
        height="180"
      />
      <figcaption class="item-content">
        <h2 class="item-title">Fly talks</h2>
        <p class="item-description">
          Tražiš posao? Kroz kratke jedan na jedan razgovore s poslodavcima saznaj jesi li upravo ti ono što traže.
          Odaberi svoju skupinu i pokaži im što znaš.
        </p>
        <router-link v-bind:to="{ path: 'app/fly-talks' }">
          <button class="item-cta">Prijavi se</button>
        </router-link>
      </figcaption>
    </figure>
    <figure class="item-wrapper" v-if="features.prizes">
      <img
        class="item-image"
        draggable="false"
        src="@/assets/app-icons/home/prizes.png"
        alt="Nagrade"
        onmousedown="return false"
        width="240"
        height="180"
      />
      <figcaption class="item-content">
        <div>
          <h2 class="item-title">Nagradna igra</h2>
          <p class="item-description">
            Prilikom svakog sudjelovanja na nekom od sadržaja konferencije, dobit ćeš kod kojeg trebaš upisati, a bodovi
            se sami zbrajaju. One najaktivnije čekaju vrijedne nagrade.
          </p>
        </div>
        <router-link v-bind:to="{ path: 'app/prizes' }">
          <button class="item-cta">Unesi kod</button>
        </router-link>
      </figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'ScrollingLinks',
  data() {
    return {
      exploreSliderRenderCount: 0,
    };
  },
  props: ['features'],
};
</script>

<style scoped>
.scrolling-links {
  display: flex;
  overflow: auto;
  align-items: center;
  justify-content: space-between;
  margin-right: -24px;
  margin-left: -24px;
  max-width: 1440px;
}

@media screen and (min-width: 499px) {
  .scrolling-links {
    overflow: initial;
    margin-right: 0;
  }
}

.item-wrapper {
  margin: 0;
  margin-right: 18px;
}

.item-wrapper:first-child {
  padding-left: 24px;
}

.item-wrapper:last-child {
  margin-right: 0;
  padding-right: 24px;
}

@media screen and (min-width: 1023px) {
  .item-wrapper {
    display: flex;
  }

  .item-wrapper:last-child {
    padding-right: 0;
  }
}

.item-image {
  border-radius: 20px;
  margin-bottom: 24px;
}

@media screen and (min-width: 767px) {
  .item-image {
    width: 295px;
    height: 200px;
  }
}

@media screen and (min-width: 1023px) {
  .item-image {
    width: 240px;
    height: 180px;
    margin-right: 20px;
  }
}

@media screen and (min-width: 1439px) {
  .item-image {
    width: 295px;
    height: 200px;
  }
}

.item-content {
  max-width: 240px;
}

@media screen and (min-width: 767px) {
  .item-content {
    max-width: 256px;
  }
}

.item-title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 4px;
}

.item-description {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
  margin-bottom: 16px;
}

.item-cta {
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  border: 0;
  padding: 12px 32px;
  background-color: #30cec2;
  border-radius: 15px;
  transition: background-color 0.3s ease-in-out;
}

.item-cta:hover {
  background-color: #35e5d8;
}
</style>
